











































































































import {
  SfInput, SfImage, SfCheckbox,
} from '~/components/StorefrontUi';
import {
  defineComponent, computed, ref, useContext,
} from '@nuxtjs/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { addBasePath } from '~/helpers/addBasePath';
import { useUiNotification } from '~/composables/useUiNotification';
import { SHOP_TITLE } from '~/config/base';

extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

export default defineComponent({
  components: {
    SfCheckbox,
    SfInput,
    SfImage,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  setup({ blok }) {
    const { send: sendNotification } = useUiNotification();
    const { app } = useContext();
    const isRulesChecked = ref<boolean>(false);
    const newsletterEmail = ref<string>('');
    const backgroundImageURL = computed(
      () => `${blok?.background?.filename}/m/`,
    );
    const submitForm = async (reset: () => void) => {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'subscribe',
        eventAction: 'subscribe',
        customer_tags: blok?.customer_tag || 'storyblok_newsletter',
        email: newsletterEmail.value,
      });

      const response = await fetch('/api/submit-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: newsletterEmail.value }),
      });
      const isResponseOk = response.status === 200;

      sendNotification({
        id: Symbol('newsletter_updated'),
        message: app.i18n.t(isResponseOk ? 'Subscribed to the newsletter' : 'Newsletter signup error') as string,
        type: isResponseOk ? 'success' : 'danger',
        icon: 'cross',
        persist: false,
        title: 'Newsletter',
      });
      if (isResponseOk) {
        reset();
        newsletterEmail.value = '';
        isRulesChecked.value = false;
      }
    };

    return {
      addBasePath,
      submitForm,
      isRulesChecked,
      newsletterEmail,
      backgroundImageURL,
      SHOP_TITLE,
    };
  },
});
